import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchPayNowStatus } from '../query-api'

interface UsePayNowStatusProps {
  enabled?: boolean
}

export const usePayNowStatus = ({ enabled = true }: UsePayNowStatusProps = {}) => {
  const { organization, isLoading: isOrganizationLoading } = useUserOrganization()
  const organizationId = organization?.id

  const {
    data,
    isLoading: isPayNowStatusLoading,
    isError,
    refetch,
  } = useQuery([QueryKeys.PayNowStatus, organizationId], fetchPayNowStatus, {
    enabled: enabled && Boolean(organizationId),
  })

  const isConnected = Boolean(data?.connected)
  // active implies connected: an org can only be actively taking payments if a connection exists,
  // so we guard on both rather than trusting `active` alone.
  const isActive = Boolean(data?.connected && data?.active)

  return {
    hasPayNowSettings: data?.hasPaynowSettings,
    isActive,
    isConnected,
    isError,
    isLoading: isOrganizationLoading || isPayNowStatusLoading,
    payNowStatus: data,
    refetch,
  }
}
